const base = '/appointment'

export const appointment = {
    appointment: `${base}`,
    editAppointment: `${base}/patient`
}